import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import SideMenu from '@shared/side-menu';
import AccountNavigation from '@molecule/account-navigation';
import { selectors as profileSelectors } from '@clearscore/redux.profile';
import { selectors as marketSelectors } from '@clearscore/redux.market';

import LogoNavigation from '../logo-navigation';
import ProgressNavigation from '../progress-navigation';
import styles from './progress-header.css';
import marketConfig from './lib/market-config';

const ProgressHeader = ({ urlMarket }) => {
    const { firstName } = useSelector(profileSelectors.getSimple);
    const activeMarket = useSelector(marketSelectors.getActiveMarket);
    const { progressIndicatorEnabled } = marketConfig({ market: urlMarket || activeMarket });

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const handleMenuToggle = () => setIsMenuOpen(!isMenuOpen);

    return (
        <header className={styles.header} role="navigation">
            <LogoNavigation progressIndicatorEnabled={progressIndicatorEnabled} />

            <Choose>
                <When condition={progressIndicatorEnabled}>
                    <ProgressNavigation menu="registration" className={styles.headerCenter} />
                </When>
                <Otherwise>
                    <div className={styles.spacer} />
                </Otherwise>
            </Choose>

            <div data-qa="account-nav-holder" className={progressIndicatorEnabled ? null : styles.headerHiddenSidebar}>
                <AccountNavigation firstName={firstName} handleAccountToggle={handleMenuToggle} />
                <SideMenu market={urlMarket} isOpen={isMenuOpen} closeDrawer={handleMenuToggle} />
            </div>
        </header>
    );
};

ProgressHeader.propTypes = {
    urlMarket: PropTypes.string,
};

ProgressHeader.defaultProps = {
    urlMarket: null,
};

export default ProgressHeader;
